import React from 'react';
import { uniqueId, isEmpty } from 'lodash';
import request from 'utils/request_ajax';
import DataCardTitle from './DataCard/Title';

class InsightsTable extends React.Component {
  state = {
    data: null,
    error: false,
    filtered: null,
  };

  componentDidMount() {
    this.setFilteredState();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.source !== this.props.source ||
      prevProps.filteredSource !== this.props.filteredSource
    ) {
      this.requestData();
    }
  }

  setFilteredState = () => {
    const filtered =
      this.props.filteredSource &&
      sessionStorage.getItem('filtered') !== 'false';

    this.setState({ filtered }, this.requestData);
  };

  requestData = () => {
    const source = this.state.filtered
      ? this.props.filteredSource
      : this.props.source;

    if (source) {
      request
        .get(source)
        .then(data => this.setState({ data }))
        .fail(() => this.setState({ error: true }));
    }
  };

  handleFilterClick = () => {
    this.setState(
      state => ({ filtered: !state.filtered }),
      () => {
        this.requestData();
        sessionStorage.setItem('filtered', this.state.filtered);
      },
    );
  };

  render() {
    const {
      title,
      tooltip,
      subtitle,
      rowComponent,
      i18n,
      customClass,
      filterableBy,
      filteredSource,
    } = this.props;
    const { data, error, filtered } = this.state;

    return (
      <div className={customClass || null}>
        {title && (
          <DataCardTitle title={title} tooltip={tooltip} subtitle={subtitle} />
        )}
        {error && i18n.error}
        {!data && !error && i18n.loading}
        {data && isEmpty(data.results) && !error && `${i18n.no_results}.`}
        {data && !isEmpty(data.results) && !error && (
          <ul className="zebra ls-n">
            {data.results.map((result, index) =>
              React.createElement(rowComponent, {
                key: uniqueId(title),
                rowData: result,
                number: index + 1,
              }),
            )}
          </ul>
        )}
        {filterableBy && filteredSource && (
          <div className="mt-16">
            <input
              defaultChecked={filtered}
              onClick={this.handleFilterClick}
              type="checkbox"
            />
            <span className="ml-4 c-brand-gray-dark">
              {i18n.exclude} {filterableBy}
            </span>
          </div>
        )}
      </div>
    );
  }
}

export default InsightsTable;
